import ApolloClient from 'apollo-boost';
import { API_KEY, API_URL, API_REGION } from './config';
import { Session, DataError, Event } from './types';
import { EXCHANGE_SHARECODE_MUTATION, LIST_HISTORY_QUERY } from './graphql';

const client = new ApolloClient({
  uri: API_URL,
  headers: {
    'X-API-KEY': API_KEY
  }
});

const AUTH_ERROR_MESSAGES = {
  INVALID: 'The share code you have entered is invalid. Please try again',
  EXPIRED: 'The share code you have entered has expired',
  ALREADY_USED: 'The share code you have entered has already been used',
  DEFAULT: 'Something went wrong with the share code validation. Please try again'
};

enum AuthErrorTypes {
  INVALID_CODE,
  EXPIRED_CODE,
  CODE_ALREADY_EXCHANGED
}

const flattenErrors = (error: any) =>
  error.graphQLErrors.map((error: DataError) => error.message).join(',');

const handleAuthErrors = (error: any) => {
  return error.graphQLErrors.map((error: DataError) => {
    switch (error.errorType) {
      case AuthErrorTypes[AuthErrorTypes.INVALID_CODE]:
        return (error.message = AUTH_ERROR_MESSAGES.INVALID);
      case AuthErrorTypes[AuthErrorTypes.EXPIRED_CODE]:
        return (error.message = AUTH_ERROR_MESSAGES.EXPIRED);
      case AuthErrorTypes[AuthErrorTypes.CODE_ALREADY_EXCHANGED]:
        return (error.message = AUTH_ERROR_MESSAGES.ALREADY_USED);
      default:
        return (error.message = AUTH_ERROR_MESSAGES.DEFAULT);
    }
  });
};

const authenticate = async (shareCode: string) => {
  try {
    const result = await client.mutate({
      mutation: EXCHANGE_SHARECODE_MUTATION,
      variables: { shareCode }
    });
    const session: Session = {
      token: result.data.exchangeShareCode.token,
      expiry: result.data.exchangeShareCode.expiry
    };
    return session;
  } catch (err) {
    throw new Error(handleAuthErrors(err));
  }
};

const fetchHistory = async (session: string, limit: number, token?: string) => {
  try {
    const result = await client.query({
      query: LIST_HISTORY_QUERY,
      variables: { session, limit, token }
    });
    const data: { events: Event[]; nextToken: string } = result.data.listHistory;
    return data;
  } catch (err) {
    throw new Error(flattenErrors(err));
  }
};

export { authenticate, fetchHistory, Event };
